

exports.__esModule = true;

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoSidebarComponent', {

    tag: 'xo-sidebar',
    template: _template2['default'],

    props: {
        token: {
            required: false,
            type: 'var'
        },
        backUri: {
            required: false,
            type: 'var'
        },
        doneUri: {
            required: false,
            type: 'var'
        },
        promotion: {
            required: false,
            type: 'var'
        },
        update: {
            required: false,
            type: 'var'
        },
        installment: {
            required: false,
            type: 'var'
        },
        strictAddressNormalization: {
            required: false,
            type: 'var'
        },
        shippingChangeFeature: {
            required: false,
            type: 'var'
        },
        shippingAddress: {
            required: false,
            type: 'var'
        },
        onAddressNormalized: {
            required: false,
            type: 'var'
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            _squid.$util.assert(this.props.backUri, 'Expected backUri');
            this.sidebar = true;
            this.backUri = this.props.backUri;
            this.doneUri = this.props.doneUri;
            this.onPageClick = function ($event) {
                $event.stopPropagation();
            };

            /**
             * Stores history of sidebar nested routes to be able to go to
             * previous sidebar routes by calling back() on sidebar.
             */
            this.history = [this.props.backUri];
            this.cancelStateListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
                var index = _this.history.indexOf(to.name);

                if (index === -1) {
                    _this.history.push(from.name);
                } else {
                    _this.history = _this.history.slice(0, index);
                }
            });

            this.back = function () {
                _uiRouter.$state.go(_this.history[_this.history.length - 1]);
            };

            this.close = function () {
                _uiRouter.$state.go(_this.props.backUri);
            };

            this.callbacks = {
                done: function done() {
                    _uiRouter.$state.go(this.doneUri || 'checkout.review');
                }
            };
        },
        populate: function populate() {
            this.ryi = document.getElementById('ryiForm');
            this.ryi && this.ryi.setAttribute('aria-hidden', true); // eslint-disable-line no-unused-expressions

            (0, _jquery2['default'])('body').addClass('trayOpen');
            (0, _jquery2['default'])('#wrapper').addClass('maskMember');

            var payButton = (0, _jquery2['default'])('.confirmButton');

            if (payButton) {
                payButton.attr('disabled', true);
            }
        },
        exit: function exit() {
            (0, _jquery2['default'])('body').removeClass('trayOpen');

            // Ensure `RYI` page can be read via voice over devices when
            // users come back from other pages
            this.ryi && this.ryi.setAttribute('aria-hidden', false); // eslint-disable-line no-unused-expressions

            var payButton = (0, _jquery2['default'])('.confirmButton');

            if (payButton) {
                payButton.attr('disabled', false);
            }

            this.cancelStateListener();
        }
    }
});


_angular.$rootScope;

_uiRouter.$state;

_squid.$Component;

_squid.$util;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar/directive.js
// module id = ./pages/xo-sidebar/directive.js
// module chunks = 0